const defaultConfig = {
  MOCK: false,
  LANGUAGE: 'de',
  WEBSHOP_ENDPOINT_LANG: 'de_CH',
  WEBSHOP_ENDPOINT: 'https://shop.loasia.ch',
  WEBSHOP_CUSTOMERPROFILE: '/customerdata/overview',
  WEBSHOP_PRODUCTLIST: '/listArticle',
  WEBSHOP_LOGIN: '#/login',
  WEBSHOP_CONTAO_ENDPOINT: '',
  WEBSHOP_ENDPOINT_TAKEAWAY: '/storedata/selectStore?store_id=%s&deliveryarea_id=%s',
  WEBSHOP_ENDPOINT_DELIVERY: '/storedata/selectStore?store_id=%s&deliveryarea_id=%s',
  CONTAOPROXY: true,
  CART_COOKIE: 'cstore',
  MOCK_COOKIE: 'loasiamock',
  MOCK_FULLBASKET: true,
  MOCK_LOGGEDIN: true,
  MOCK_BASKET_URL: '/files/mock_lnmedia/current/getBasketSummary-full.json',
  MOCK_BASKET_EMPTY_URL: '/files/mock_lnmedia/current/getBasketSummary-empty.json',
  MOCK_SEARCHZIP_URL: '/files/mock_lnmedia/current/pointindeliveryareapolygons-8800.json',
  MOCK_SEARCHZIP_EMPTY_URL: '/files/mock_lnmedia/current/pointindeliveryareapolygons-99999.json',
  MOCK_LASTORDER_URL: '/files/mock_lnmedia/current/listOrderPublic-loggedin.json',
  MOCK_LASTORDER_EMPTY_URL: '/files/mock_lnmedia/current/listOrderPublic-normal.json',
  MOCK_SELECTORDER_URL: '/files/mock_lnmedia/current/selectOrderPublic.json',

  // OLD CONFIG
  responsive: {
    mobile: 768
  }
}

const overrideConfig = {}

export function readFromComponentOptions (opts) {
  for (var i in opts) {
    if (Object.prototype.hasOwnProperty.call(cfg, i)) {
      cfg[i] = opts[i]
    }
  }
}
export function readFromHtmlJson (cfg) {
  const el = document.querySelector('#baseconfig')
  if (el && el.getAttribute('type') === 'application/json') {
    const data = JSON.parse(el.innerHTML.replace(/^\s+/, ''))
    return data
  }
  return {}
}
function readFromCookie (config) {
  const cfg = {}
  cfg.MOCK = (window.localStorage.getItem(config.MOCK_COOKIE) || 'false') === 'true'
  cfg.MOCK_FULLBASKET = (window.localStorage.getItem(config.MOCK_COOKIE + 'fullbasket') || 'true') === 'true'
  cfg.MOCK_LOGGEDIN = (window.localStorage.getItem(config.MOCK_COOKIE + 'loggedin') || 'true') === 'true'
  return cfg
}
export function updateConfig () {
  const config = {}
  const cfg = config || { ...defaultConfig }
  Object.assign(cfg, overrideConfig)
  Object.assign(cfg, readFromHtmlJson(cfg))
  Object.assign(cfg, readFromCookie(cfg))
  Object.assign(cfg, overrideConfig)
  return cfg
}
export function setConfigValue (key, value) {
  overrideConfig[key] = value
  updateConfig()
}

const cfg = updateConfig()
window.loasia_config = cfg
export const config = cfg
